/**
 * @generated SignedSource<<2bd932c217855ddd3032828bca975f90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RequestAddAttachmentInput = {
  clientMutationId?: string | null;
  contentId?: string | null;
  contentLength?: number | null;
  contentType?: string | null;
  filename: string;
};
export type AttachmentsRelayAddMutation$variables = {
  input: RequestAddAttachmentInput;
};
export type AttachmentsRelayAddMutation$data = {
  readonly requestAddAttachment: {
    readonly attachment: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    } | null> | null;
    readonly fields: any | null;
    readonly ok: boolean;
    readonly url: string | null;
  };
};
export type AttachmentsRelayAddMutation = {
  response: AttachmentsRelayAddMutation$data;
  variables: AttachmentsRelayAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestAddAttachmentPayload",
    "kind": "LinkedField",
    "name": "requestAddAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fields",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "attachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AttachmentsRelayAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AttachmentsRelayAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9aa2b07981fe60c9a5625aabc3e6a040",
    "id": null,
    "metadata": {},
    "name": "AttachmentsRelayAddMutation",
    "operationKind": "mutation",
    "text": "mutation AttachmentsRelayAddMutation(\n  $input: RequestAddAttachmentInput!\n) {\n  requestAddAttachment(input: $input) {\n    ok\n    fields\n    url\n    attachment {\n      id\n    }\n    errors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbcbe5cfea4f0a56b82244889ac9fd8e";

export default node;
